import { ThemeProvider } from '@mui/material/styles'
import deepmerge from 'deepmerge'
import React from 'react'

import footerTheme from '@components/branding/footerTheme'
import HealthSherpaForAgentLogo from '@components/branding/healthsherpa-for-agents-logo'
import { Box, Divider, Link, Stack, Text } from '@components/ui'
import CONTACTS from '@constants/contacts'
import URLS from '@constants/urls'

const Footer = () => (
  <ThemeProvider theme={(outerTheme) => deepmerge(outerTheme, footerTheme)}>
    <Stack component="footer" direction="column">
      <Box padding={6}>
        <Box display="flex" justifyContent="center" padding={2}>
          <HealthSherpaForAgentLogo variant="white" />
        </Box>
        <Box paddingBottom={2}>
          <Text align="center" variant="avenir14">
            {'An ACA enrollment platform designed just for agents. '}
            <Link href={URLS.learnMoreAboutPlatform}>Learn more</Link>
          </Text>
        </Box>
      </Box>
      <Box>
        <Stack sx={{ maxWidth: '870px', margin: '0 auto' }} spacing={1} paddingX={2}>
          <Box paddingBottom={2}>
            <Divider />
          </Box>
          <Text variant="avenir11">
            Attention: This website is operated by HealthSherpa and is not the Marketplace Learning
            Management System (MLMS) website operated by the Centers for Medicare & Medicaid
            Services (CMS). CMS has approved the content of the Marketplace agent and broker
            training offered through this website. Successful completion of the training will
            satisfy the training component of the registration requirement for agents and brokers
            who wish to participate in the Marketplace. Please note that CMS does not assume
            responsibility for any errors that may exist within this content to the extent that such
            content has not been approved by CMS.
          </Text>
          <Text variant="avenir11">
            <Link href={URLS.termsOfService} rel="noreferrer" target="_blank">
              Agent Terms of Use
            </Link>
          </Text>
          <Text variant="avenir11">
            Health Insurance Marketplace℠ and Marketplace℠ are service marks of the United States
            Department of Health & Human Services. When used in this document, the term “Health
            Insurance Marketplace” or “Marketplace” refers to Federally-facilitated Marketplaces
            (FFMs) including FFMs where states perform plan management functions, and also refers to
            State-based Marketplaces on the Federal Platform (SBM- FPs).
          </Text>
          <Box paddingTop={2}>
            <Divider />
          </Box>
        </Stack>
      </Box>
      <Stack textAlign="center" spacing={2} padding={8}>
        <Box>
          <Text variant="avenir12Bold">CONTACT SUPPORT</Text>
          <Text variant="avenir12">{CONTACTS.supportPhone}</Text>
          <Text variant="avenir12">{CONTACTS.supportEmail}</Text>
        </Box>

        <Box>
          <Text variant="avenir12Bold">Weekday hours</Text>
          <Text variant="avenir12">6:00am - 4:00pm PST</Text>
        </Box>

        <Box>
          <Text variant="avenir12Bold">Saturday hours</Text>
          <Text variant="avenir12">Closed</Text>
        </Box>

        <Box>
          <Text variant="avenir12Bold">Sunday hours</Text>
          <Text variant="avenir12">Closed</Text>
        </Box>
      </Stack>
    </Stack>
  </ThemeProvider>
)

export default Footer
